<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q0pefM/media/FC-9781398431348.jpg?1721600811848" alt="This image is the cover for the book Crowning Glory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crowning Glory
      </h1>
      <p class="bookDescription body article font2">
        <p>As a nation, we like to think we know everything about our Kings and Queens. William I conquered in 1066, Henry VIII had six wives and Queen Victoria was ‘not amused’… But do these ‘pub-quiz facts’ provide a genuine picture of what our monarchs were really like as living, breathing people? As the reader shall find, there is a treasure-trove of wit, wisdom and wonder waiting to be discovered. Crowning Glory wipes away the cobwebs of fuddy-duddy facts and breathes new life into this surprisingly addictive aspect of history. It challenges our basic understanding of the subject by introducing readers to a colourful cast of characters and revealing little-known insights. This book reminds us that, behind the formality of the crown, are real human beings. Like you and me, they have known success, failure, sorrow, and laughter. The lives of our kings and queens are so much more vivid than boring, old dates, figures, and facts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Allen
      </h2>
      
      <p class="authorDescription body article">Matthew is an experienced teacher of history with a lifelong passion for the British monarchy. From childhood, he has been enthralled by the unique lives of our Kings and Queens. Amassing a vast body of knowledge on the subject, he is a writer for the Constitutional Monarchy Association and publishes academic articles in ‘The Crown’, a quarterly journal. When he is not teaching or writing, Matthew enjoys keeping up to date with the Royal Family and spending time with his much loved family (especially his godson and nephew – Luca).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?301dc01e